// extracted by mini-css-extract-plugin
module.exports = {"loadMore":"tag-list_loadMore__2zAiL","moreHeight":"tag-list_moreHeight__21uVF","tagList":"tag-list_tagList__vzhJ5"};